import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { memo } from "react";

interface PropertySearchBarProps {
    value: string;
    placeholder: string;
    onChange: (value: string) => void;
    onClear: () => void;
}

const PropertySearchBar = memo(({ value, placeholder, onChange, onClear }: PropertySearchBarProps) => (
    <div className="items-center mx-4 mb-2">
        <small>
            <Input
                startIcon={Search}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.currentTarget.value)}
                onClear={onClear}
            />
        </small>
    </div>
));

PropertySearchBar.displayName = "PropertySearchBar";

export default PropertySearchBar;
